// NPM
import React, { useState } from 'react';
import _ from 'lodash'
import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'

// Components

const TeamMember = ({ 
  teamMember, 
  openBioText,
  closeBioText, 
  viewingBio, 
  setViewingBio,
  teamMemberIndex,
  selectedTeamMemberIndex,
  onClick
}) => {
  return (
    <div className="TeamMember" onClick={ onClick }>
      <img 
        className="TeamMember__avatar"
        src={ teamMember.avatar.url } 
        alt={ teamMember.longName } 
      />

      <h4 className="TeamMember__name">
        { teamMember.longName }
      </h4>

      <p className="TeamMember__role">
        { teamMember.role }
      </p>

      {
        selectedTeamMemberIndex === teamMemberIndex &&
          <button 
            className="TeamMember__bio-button"
            onClick={ e => {
              e.preventDefault()
              e.stopPropagation()
              setViewingBio(!viewingBio) 
            }}>
              {
                viewingBio &&
                  <React.Fragment>
                    <span>
                      { closeBioText }
                    </span>
                    <img 
                      src={ require("src/images/pages/About/bio-close.png").default }
                      className="TeamMember__bio-button-arrow"
                    />
                  </React.Fragment>
              }

              {
                !viewingBio &&
                  <React.Fragment>
                    <span>
                      { openBioText }
                    </span>
                    <img 
                      src={ require("src/images/pages/About/bio-open.png").default }
                      className="TeamMember__bio-button-arrow"
                    />
                  </React.Fragment>
              }
          </button>
      }

      {
        viewingBio && selectedTeamMemberIndex === teamMemberIndex &&
          <ReactMarkdown
            className="TeamMember__bio"
            children={ _.get(teamMember, `bio.data.bio`, '') }
            rehypePlugins={[rehypeRaw]}
          />
      }
    </div>
  )
}

export default TeamMember